import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerioCheatSheetKeyComponent } from '../perio-cheat-sheet-key/perio-cheat-sheet-key.component';

@Component({
  selector: 'lib-perio-cheat-sheet-row',
  imports: [CommonModule, PerioCheatSheetKeyComponent],
  templateUrl: './perio-cheat-sheet-row.component.html',
  styleUrl: './perio-cheat-sheet-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioCheatSheetRowComponent {
  public readonly disabled = input<boolean>(false);
}
